import React from "react";
import ReactDOM from "react-dom/client";
import "@/lib/pwaInstall";
import "@/index.css";
import App from "@/App";

// ── Silence verbose console output in production ─────────────────────────
// Keeps `console.warn` and `console.error` (real issues still surface) but
// turns `console.log/info/debug` into no-ops. Prevents leaking internal
// state, reduces main-thread work and keeps the devtools clean.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
